import { render, staticRenderFns } from "./demand.vue?vue&type=template&id=21fb7ed4&scoped=true&"
import script from "./demand.vue?vue&type=script&lang=js&"
export * from "./demand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fb7ed4",
  null
  
)

export default component.exports